import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1f5f5ba6&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "@fortawesome/fontawesome-free/css/all.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/styles/tailwind.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/styles/app.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports